import gameData, { GameVersions } from './gameData';

export default function setupGameConfig(variantId) {
  const config = {
    // add your game config options here, these can be the default values
    showOptions: false,
    gameMode: 'practice', // practice or race
    titleGraphic: null
  };
  if (gameData.gameVersion === GameVersions.Number) {
    switch (variantId) {
      // switch on your variant IDs here and set the needed config values
      case 'practice-a': // grade 2
        config.gameMode = 'practice';
        break;
      case 'race-a': // grade 3
        config.gameMode = 'race';
        config.titleGraphic = 'title-race-variant';
        break;
      default:
        config.showOptions = true;
        break;
    }
  }
  else {
    config.showOptions = true;
  }

  return config;
}